import React from 'react';
import {
    BarChart as RechartsBarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from 'recharts';
import './GroupedBarChart.scss';

const GroupedBarChart = ({
    data = [],
    xAxisKey = 'name',
    bars = [],
    height = 300,
    showGrid = true,
    showTooltip = true,
    showLegend = true,
    yAxisLabel,
    xAxisLabel,
    formatTooltip,
    loading = false
}) => {
    if (loading) {
        return (
            <div className="chart-loading" style={{ height: `${height}px` }}>
                <div className="loading-skeleton"></div>
            </div>
        );
    }

    if (!data || data.length === 0) {
        return (
            <div className="chart-empty" style={{ height: `${height}px` }}>
                <p>No data available</p>
            </div>
        );
    }

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip">
                    <p className="tooltip-label">{label}</p>
                    {payload.map((entry, index) => (
                        <p key={index} style={{ color: entry.color }}>
                            {entry.name}: {formatTooltip ? formatTooltip(entry.value) : entry.value}
                        </p>
                    ))}
                </div>
            );
        }
        return null;
    };

    return (
        <div className="grouped-bar-chart-container">
            <ResponsiveContainer width="100%" height={height}>
                <RechartsBarChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
                    {showGrid && <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />}
                    <XAxis 
                        dataKey={xAxisKey} 
                        stroke="#666"
                        tick={{ fontSize: 12 }}
                        label={xAxisLabel ? { value: xAxisLabel, position: 'insideBottom', offset: -5 } : null}
                    />
                    <YAxis 
                        stroke="#666"
                        tick={{ fontSize: 12 }}
                        label={yAxisLabel ? { value: yAxisLabel, angle: -90, position: 'insideLeft' } : null}
                    />
                    {showTooltip && <Tooltip content={<CustomTooltip />} />}
                    {showLegend && <Legend />}
                    {bars.map((bar, index) => (
                        <Bar
                            key={bar.key || index}
                            dataKey={bar.key}
                            fill={bar.color}
                            name={bar.name}
                        />
                    ))}
                </RechartsBarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default GroupedBarChart;


